<!--
  筛选&过滤面板
  props:
    belonger: 筛选范围
    tableHead: 表头（库存查询模块searchItems没有表头）
  emit:
    refresh: 提交刷新列表请求
    ssChange: 提交筛选条件变更请求
 -->

<template>
  <div class="content-head">
    <!-- 分组 -->
    <el-select
      v-if="groupList.length && moduleName !== 'productStock'&& moduleName !== 'productApi'"
      v-model="manager"
      class="manager"
      size="small"
      popper-class="custom-select">
      <el-option
        v-for="item in groupList"
        :key="item.key"
        :label="item.value"
        :value="item.key">
      </el-option>
      <div class="custom-select-option" @click="openGroup" v-if="isSummit">分组管理</div>
    </el-select>

    <!-- 库存列表中全部产品插槽 -->
    <slot name="allPro"></slot>
     <!-- 全部仓库 -->
     <el-select
      v-if="moduleName === 'productStock'"
      v-model="manager"
      class="stock"
      size="small"
      popper-class="custom-select">
        <el-option
        v-for="item in groupList"
        :key="item.key"
        :label="item.value"
        :value="item.key">
        </el-option>
     </el-select>
     <!-- 库存查询和产品列表中产品分类插槽 -->
     <slot name="proClass"></slot>

    <!-- 范围 -->
    <div
      class="scope"
      v-clickoutside="closeFilter"
      v-if="['1', '2'].indexOf(belonger.belongerType) === -1 && moduleName !== 'productApi' && moduleName !== 'waitPurchaseApi' && moduleName !== 'waitInstockPurchase' && moduleName !== 'waitOutstock' && moduleName !== 'productStock' && moduleName !== 'waitProduce' && showScope">
      <label class="label">范围筛选</label>
      <el-input size="small" placeholder="请选择" v-model="userName" @focus="scopeFilter" readonly>
        <el-select
          v-model="belonger.isMain"
          slot="prepend"
          v-if="['3', '4'].indexOf(belonger.belongerType) === -1 &&　rangeType">
          <el-option label="负责" :value="1" key="1"></el-option>
          <el-option v-if="rangeType!==1" label="协同" :value="0" key="0"></el-option>
        </el-select>
      </el-input>
      <i class="el-icon-close" @click="clearSelect" v-if="userName"></i>
      <div class="dropbox-wrapper">
        <transition name="fade">
          <v-dropbox v-if="scopeShow" @staff="staffSelect" @department="departmentSelect"></v-dropbox>
        </transition>
      </div>
    </div>

    <!-- 待采购、待生产搜索 -->
    <div class="wait-list-filter" v-if="['waitPurchaseApi', 'waitProduce'].indexOf(moduleName) > -1">
      <template v-if="belonger.belongerType === '1'">
        <div class="form-item">
          <label class="label">关联合同:</label>
          <input type="text"
            class="vw-input"
            v-model="searchAttr.contractLike"
            @change="handleSelect($event, 'contractLike')"
            placeholder="请输入合同名称或编号">
          <i class="el-icon-close" v-if="searchAttr.contractLike" @click="clearValue('contractLike')"></i>
        </div>
        <div class="form-item">
          <label class="label">客户名称:</label>
          <input type="text"
            class="vw-input"
            v-model="searchAttr.customerLike"
            @change="handleSelect($event, 'customerLike')"
            placeholder="请输入关键字">
          <i class="el-icon-close" v-if="searchAttr.customerLike" @click="clearValue('customerLike')"></i>
        </div>
      </template>
      <template v-else>
        <div class="form-item">
          <label class="label">缺货产品:</label>
          <input type="text"
            class="vw-input"
            v-model="searchAttr.productLike"
            @change="handleSelect($event, 'productLike')"
            placeholder="请输入关键字">
          <i class="el-icon-close" v-if="searchAttr.productLike" @click="clearValue('productLike')"></i>
        </div>
        <div class="form-item" v-if="moduleName === 'waitPurchaseApi'">
          <label class="label">供应商:</label>
          <input type="text"
            class="vw-input"
            v-model="searchAttr.supplierLike"
            @change="handleSelect($event, 'supplierLike')"
            placeholder="请输入关键字">
          <i class="el-icon-close" v-if="searchAttr.supplierLike" @click="clearValue('supplierLike')"></i>
        </div>
      </template>
    </div>

    <!-- 归档插槽 -->
    <slot name="archive"></slot>
    <!-- 帮助提醒 -->
    <slot name="help"></slot>
    <div class="list-panel" v-if="moduleName !=='waitPurchaseApi' && moduleName !=='waitProduce'">
      <div class="form-item">
        <v-switch
          :value="advanced"
          onText="常用"
          offText="高级"
          @change="switchAdvanced">
        </v-switch>
      </div>
      <slot name="warningType"></slot>
      <div class="form-item" v-for="item in initValue" v-if="item.searchItem === 1 && !advanced">
        <v-filter :item="item"></v-filter>
      </div>

      <!-- 回款、付款筛选 -->
      <div class="form-item">
        <ul class="payment">
          <li class="item" v-for="item in paymentStatus" :class="{active: item.key===currentIndex}" @click="handleType(item.key)">{{item.value}}</li>
        </ul>
      </div>

      <!-- 排序设置 -->
      <div class="filter sort" v-if="['paymentApi', 'payPlan', 'waitOutstock', 'waitInstockPurchase'].indexOf(moduleName) === -1">
        <el-button type="text" size="small" @click="setSortShow = true">列表设置</el-button>
      </div>

      <!-- 设置筛选 -->
      <div class="filter left" v-if="['paymentApi', 'payPlan', 'invoice', 'waitOutstock', 'waitInstockPurchase'].indexOf(moduleName) === -1">
        <el-tooltip content="常用筛选设置" placement="top" effect="light">
          <span class="title" @click="setFilterShow = true">
            <i class="web-icon-filter"></i>
          </span>
        </el-tooltip>
      </div>
    </div>
    <group-list v-if="groupListShow" @closeDialog="groupListShow=false" :templateId="curTemplate ? curTemplate.key : ''" @refresh="getSearchItem"></group-list>

    <set-filter v-if="setFilterShow" :type="type" :templateId="curTemplate ? curTemplate.key : ''" @closeDialog="setFilterShow=false" @refresh="getSearchItem"></set-filter>

    <set-sort v-if="setSortShow" :sortArray="sortArray" :initValue="initValue" :templateId="curTemplate ? curTemplate.key : ''" @closeDialog="setSortShow=false" @refresh="filterSelect"></set-sort>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import * as utils from 'src/utils'
import * as api from 'src/api'
import { exportMap } from 'src/config/common-config'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import vDropbox from 'components/common/dropbox'
import vSwitch from 'components/common/switch'
import vFilter from 'components/common/filter'
import GroupList from 'components/modal/customer/group-list'
import SetFilter from 'components/modal/set-filter'
import SetSort from 'components/modal/set-sort'

export default {
  created () {
    if (this.moduleName !== 'contractApi' && this.moduleName !== 'customerApi') {
      this.getSearchItem()
    }
  },
  props: ['belonger', 'tableHead', 'sortArray', 'curTemplate'],
  data () {
    return {
      userName: '',
      manager: '0',
      scopeShow: false,
      initValue: [],
      groupList: {},
      panel: {},
      filter: [],
      // 是否开启分组管理
      isSummit: false,
      // 控制分组列表显示
      groupListShow: false,
      rangeType: 0,
      // 回、付款筛选
      paymentStatus: {},
      // 当前的状态
      currentIndex: '0',
      // 待采购待生产筛选项
      searchAttr: {
        contractLike: '',
        customerLike: '',
        productLike: '',
        supplierLike: ''
      },
      setFilterShow: false,
      setSortShow: false
    }
  },
  computed: {
    ...mapGetters([
      'freshAllList',
      'advanced',
      'moduleName'
    ]),
    // 参数
    routeQuery () {
      return this.$route.query.query
    },
    // 子路由
    routeChild () {
      return this.$route.path.split('/').pop()
    },
    showScope () {
      if (this.routeChild === 'isPublic' || this.routeChild === 'isDel') {
        return false
      } else {
        return true
      }
    },
    // 当前模块对应的type
    type () {
      return exportMap[this.moduleName]
    }
  },
  methods: {
    ...mapActions([
      'switchAdvanced',
      'filterNormal',
      'reset' // 重置待生产待采购筛选项
    ]),
    // 切换模板时，清空搜索，分组，范围筛选，归档的已选值
    clearSelectValue () {
      this.manager = '0'
      this.userName = ''
      this.initValue = []
      this.$route.params.watchPage = false
      Vue.set(this.belonger, 'belongerType', this.manager)
      Vue.set(this.belonger, 'pid', '')
      this.$emit('clearSelectValue')
    },
    getSearchItem () {
      // 切换模板时，清空搜索，分组，范围筛选，归档的已选值
      this.clearSelectValue()
      let url = `/${this.moduleName}/searchItems.html`
      let params = {
        child: this.routeChild,
        templateId: this.curTemplate ? this.curTemplate.key : ''
      }
      api.post(url, params, (data) => {
        setTimeout(() => {
          this.groupList = data.belongerType || []
        }, 500)
        // 控制负责和协同的显示
        this.rangeType = data.rangeType
        // 首页跳转
        if (this.routeQuery) {
          // 当日新增客户
          if (this.moduleName === 'customerApi') {
            data.explains.forEach(item => {
              if (item.attr === 'addTime') {
                item.value = [utils.formatDate(), utils.formatDate()]
                this.filterNormal({
                  key: 'addTime',
                  value: item.value
                })
              }
            })
            // 本周未收款列表
          } else if (this.moduleName === 'paymentApi') {
            this.handleType('3')
          }
        } else {
          if (this.moduleName === 'customerApi' || this.moduleName === 'contractApi') {
            this.$emit('refresh', 'resetPage')
          }
        }
        this.initValue = data.explains

        // 是否开启分组管理
        this.isSummit = data.isSummit || false
        // 回款or付款状态筛选
        this.paymentStatus = data.paymentStatus || []
      })
    },
    // 回、付款筛选
    handleType (value) {
      this.currentIndex = value
      this.filterNormal({
        key: 'paymentStatus',
        value: value
      })
    },
    // 待生产筛选项
    handleSelect (val, attr) {
      this.filterNormal({
        key: attr,
        value: typeof this.searchAttr[attr] === 'string' ? this.searchAttr[attr].trim() : this.searchAttr[attr] // this.str为字符串时需要去除首位空格，为数组不处理
      })
    },
    // 待采购待生产筛选
    clearValue (attr) {
      this.searchAttr[attr] = ''
      this.handleSelect(null, attr)
    },

    scopeFilter () {
      this.scopeShow = true
    },
    closeFilter () {
      // 判断是否存在级联选择框，不存在或者存在时display为none时为真
      if (!document.querySelector('.el-cascader-menus') || document.querySelector('.el-cascader-menus').style.display) {
        this.scopeShow = false
      }
    },
    filterSelect () {
      this.$emit('ssChange')
    },
    staffSelect (id, name) {
      this.userName = name
      Vue.set(this.belonger, 'treeType', 'staff')
      Vue.set(this.belonger, 'pid', id)
    },
    departmentSelect (id, name) {
      this.userName = name
      Vue.set(this.belonger, 'treeType', 'department')
      Vue.set(this.belonger, 'pid', id)
    },
    clearSelect () {
      this.userName = ''
      Vue.set(this.belonger, 'pid', '')
      Vue.set(this.belonger, 'treeType', '')
    },
    // 打开分组列表弹窗
    openGroup () {
      this.groupListShow = true
    }
  },
  watch: {
    manager () {
      // 清空待采购待生产搜索
      this.searchAttr.contractLike = ''
      this.searchAttr.customerLike = ''
      this.searchAttr.productLike = ''
      this.searchAttr.supplierLike = ''
      this.reset()

      this.userName = ''
      this.$route.params.watchPage = false
      Vue.set(this.belonger, 'belongerType', this.manager)
      Vue.set(this.belonger, 'pid', '')
    },
    belonger: {
      handler () {
        // 单纯点击左上方筛选分类才需重置列表
        if (!this.$route.params.watchPage) {
          this.$emit('refresh', 'resetPage')
        } else {
          this.manager = this.$route.params.belongerType
          this.$route.params.watchPage = false
        }
      },
      deep: true
    },
    // 监听子路由
    routeChild (val) {
      if (this.moduleName === 'customerApi') {
        this.manager = '0'
      }
    },
    // 监听 vuex中的freshList，当值被改变时，刷新列表
    freshAllList () {
      this.getSearchItem()
    }
  },
  components: {
    vDropbox,
    vSwitch,
    vFilter,
    GroupList,
    SetFilter,
    SetSort
  },
  directives: { Clickoutside }
}
</script>

<style lang="less">
  @import '../../assets/less/list-panel.less';
  .wait-list-filter{
    display: inline-block;
    margin-bottom: 5px;
    position: relative;
    .form-item{
      display: inline-block;
      position: relative;
    }
    .el-date-editor{
      position: relative;
      width: 100%;
      .el-range-input{
        font-size: 12px;
        height: 28px;
      }
      .el-input__icon {
        position: absolute;
        right: 3px;
        top: 0;
      }
      .el-range-separator {
        padding: 0 2px;
      }
      &:hover {
        .el-range__icon {
          display: none;
        }
      }
     }
    .label {
      display: inline-block;
      vertical-align: top;
      line-height: 30px;
      font-size: 13px;
      margin-right: 6px;
    }
    .label+div {
      display: inline-block;
      vertical-align: top;
      width: 130px;
    }
    .el-select {
      .el-select__tags {
        overflow: hidden;
        .el-tag {
          margin: 1px 0 1px 6px;
          height: 22px;
          line-height: 22px;
        }
      }
      .el-select__tags>span {
        white-space: nowrap;
      }
    }
    .vw-input {
      appearance: none;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      color: #1f2d3d;
      display: block;
      padding: 4px 8px;
      outline: none;
      line-height: 1;
      height: 32px;
      display: inline-block;
      box-sizing: border-box;
      transition: border-color 0.2s;
      font-size: 13px;
      &:focus {
        border-color: #008cee;
      }
    }
    .vw-input+.el-icon-close {
      position: absolute;
      background-color: #fff;
      right: 10px;
      top: 10px;
      font-size: 12px;
      color: @primary;
      cursor: pointer;
      transform: scale(0.8);
    }
    .categray {
      z-index: 100;
      position: absolute;
      left: 62px;
      top: 32px;
      width: 300px;
      box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
      max-height: 460px;
      overflow: auto;
    }
    .el-switch {
      margin-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// list-panel.vue?363e398a